import { type FC, type ComponentType } from "react";
import {
  Card,
  CardHeader,
  Avatar,
  Skeleton,
  Typography,
  styled,
} from "@mui/material";

const StyledCard = styled(Card)({
  width: "100%",
  "& .MuiCardHeader-action": { alignSelf: "center" },
});

export interface AnalyticsMetricData {
  label: string;
  icon: ComponentType;
  value?: string | number;
}

interface AnalyticsMetricProps {
  loading?: boolean;
  metric: AnalyticsMetricData;
}

export const AnalyticsMetric: FC<AnalyticsMetricProps> = ({
  loading,
  metric,
}) => {
  const Icon = metric.icon;

  if (loading) {
    return (
      <StyledCard>
        <CardHeader
          avatar={
            <Avatar sx={{ color: "white", backgroundColor: "primary.main" }}>
              <Icon />
            </Avatar>
          }
          title={
            <Typography variant="h6">
              <Skeleton
                variant="text"
                animation="pulse"
                sx={{ maxWidth: 100 }}
              />
            </Typography>
          }
          subheader={metric.label}
        />
      </StyledCard>
    );
  }

  return (
    <StyledCard>
      <CardHeader
        avatar={
          <Avatar sx={{ color: "white", backgroundColor: "primary.main" }}>
            <Icon />
          </Avatar>
        }
        title={metric.value}
        subheader={metric.label}
        slotProps={{ title: { variant: "h6" } }}
      />
    </StyledCard>
  );
};
